// src/presentation/utils/helpers.ts
import { UserRole } from "@/domain/enums/roles"

// Format date to Arabic locale
export const formatDate = (date: Date | string): string => {
  const dateObj = typeof date === "string" ? new Date(date) : date
  return dateObj.toLocaleDateString("ar-SA")
}

// Format date to Gregorian with Arabic month names
export const formatArabicDate = (dateString: string): string => {
  const date = new Date(dateString)

  const arabicMonths = [
    "يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو",
    "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
  ]

  const day = date.getDate()
  const month = arabicMonths[date.getMonth()]
  const year = date.getFullYear()

  return `${day} ${month} ${year}`
}

// Format date and time in English
export const formatDateTime = (dateString: string): string => {
  const date = new Date(dateString)

  const englishMonths = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ]

  const day = date.getDate()
  const month = englishMonths[date.getMonth()]
  const year = date.getFullYear()

  let hours = date.getHours()
  const minutes = date.getMinutes().toString().padStart(2, "0")
  const ampm = hours >= 12 ? "PM" : "AM"
  hours = hours % 12
  hours = hours ? hours : 12
  const formattedHours = hours.toString().padStart(2, "0")

  return `${day} ${month} ${year}, ${formattedHours}:${minutes} ${ampm}`
}

/**
 * Format YYYY-MM string to Arabic month and year (Gregorian calendar)
 * @param monthString - Format: YYYY-MM (e.g., "2025-01")
 * @returns Formatted string (e.g., "يناير 2025")
 */
export const formatMonthYear = (monthString: string): string => {
  const arabicMonths = [
    "يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو",
    "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
  ]

  const [year, month] = monthString.split("-")
  const monthIndex = parseInt(month, 10) - 1
  const arabicMonth = arabicMonths[monthIndex]

  return `${arabicMonth} ${year}`
}

// Truncate text with ellipsis
export const truncateText = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text
  return text.substring(0, maxLength) + "..."
}

// Check if user has permission
export const hasPermission = (
  userRole: string,
  requiredRoles: string[]
): boolean => {
  return requiredRoles.includes(userRole)
}

// Redirect user based on role
export const redirectByRole = (role: UserRole): string => {
  switch (role) {
    case UserRole.ADMIN:
      return "/admin"
    case UserRole.USER:
      return "/user/home"
    case UserRole.EVALUATOR:
      return "/evaluator"
    default:
      return "/dashboard"
  }
}

export const getDefaultRouteForRole = (role: UserRole): string => {
  return redirectByRole(role)
}